import moment from "moment"
import React from "react"
import "./RenderDiagnosticReport.scss"

function RenderDiagnosticReport({ smartSummaryData, page }: any) {

  const getLastScan = () => {
    let lastScanMessage = ""
    if (smartSummaryData?.lastScan === null) {
      return "NA"
    } else if (smartSummaryData?.lastScan) {
      if (smartSummaryData?.lastScan?.length > 0) {
        const lastIndex: any = smartSummaryData?.lastScan?.length - 1
        if (Object.keys(smartSummaryData?.lastScan[lastIndex])?.length > 0) {
          let data = Object.keys(smartSummaryData?.lastScan[lastIndex])
          let subTypeKey = data?.find((ele: any) => ele !== "test" && ele !== "test-Comment" && ele !== "dateOfTest" && ele !== "testFindings") || null

          if (data?.includes("test")) {
            if (smartSummaryData?.lastScan[lastIndex]["test"] === "other") {
              if (smartSummaryData?.lastScan[lastIndex]["test-Comment"]) {
                lastScanMessage = lastScanMessage + smartSummaryData?.lastScan[lastIndex]["test-Comment"] + ","
              } else {
                lastScanMessage = lastScanMessage + "" + ","
              }
            } else {
              lastScanMessage = lastScanMessage + smartSummaryData?.lastScan[lastIndex]["test"] + ","
            }
          }
          if (subTypeKey && data?.includes(subTypeKey)) {
            lastScanMessage = lastScanMessage + ` ${smartSummaryData?.lastScan[lastIndex][subTypeKey]}`
          }
          if (data?.includes("dateOfTest")) {
            lastScanMessage = lastScanMessage + " done on " + moment(smartSummaryData?.lastScan[lastIndex][`dateOfTest`]).format("DD-MM-YYYY")
          }
          if (data?.includes("testFindings")) {
            lastScanMessage = lastScanMessage + ". Test findings are " + smartSummaryData?.lastScan[lastIndex][`testFindings`]
          }
        }
        else {
          return "NA"
        }
      }
    }
    return lastScanMessage
  }

  const getPastTreatment = (index: any) => {
    let pastTreatmentMessage = ""
    if (smartSummaryData?.pastTreatment === null) {
      return "NA"
    } else if (Object.keys(smartSummaryData?.pastTreatment[index]).length > 0) {
      let data: any = Object.keys(smartSummaryData?.pastTreatment[index])
      if (data?.includes("treatmentIntent") && smartSummaryData?.pastTreatment[index]["treatmentIntent"]) {
        pastTreatmentMessage += `Treatment Intent : ${smartSummaryData?.pastTreatment[index]["treatmentIntent"]}`
      }
      if (data?.includes("Type") && smartSummaryData?.pastTreatment[index]["Type"]) {
        pastTreatmentMessage += `,  Treatment Type : ${smartSummaryData?.pastTreatment[index]["Type"]}`
      }
      if ((data?.includes("from") && smartSummaryData?.pastTreatment[index]["from"]) &&
        (data?.includes("to") && smartSummaryData?.pastTreatment[index]["to"])) {
        pastTreatmentMessage += `,  From : ${moment(smartSummaryData?.pastTreatment[index]["from"]).format("DD-MM-YYYY")} To : ${moment(smartSummaryData?.pastTreatment[index]["to"]).format("DD-MM-YYYY")}`
      }
      if (data?.includes("details") && smartSummaryData?.pastTreatment[index]["details"]) {
        pastTreatmentMessage += `,  Details : ${smartSummaryData?.pastTreatment[index]["details"]}`
      }

      if (data?.includes("withTargetLesions") && smartSummaryData?.pastTreatment[index]["withTargetLesions"]) {
        pastTreatmentMessage += ".\n With Target Lesions Response - "
        if (smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]) {
          if (smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["targetLesionsResponse"]) {
            pastTreatmentMessage += `Target Lesions Response : ${smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["targetLesionsResponse"]}`
          }
          if (smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["nonTargetLesionsResponse"]) {
            pastTreatmentMessage += `, Non Target Lesions Response : ${smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["nonTargetLesionsResponse"]}`
          }
          if (smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["newLesions"]) {
            pastTreatmentMessage += `, New Lesions : ${smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["newLesions"]}`
          }
          if (smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["overallResponse"]) {
            pastTreatmentMessage += `, Overall Response : ${smartSummaryData?.pastTreatment[index]["withTargetLesions"][0]["overallResponse"]}`
          }
        } else {
          pastTreatmentMessage += "NA"
        }
      } else if (data?.includes("withoutTargetLesions") && smartSummaryData?.pastTreatment[index]["withoutTargetLesions"]) {
        pastTreatmentMessage += ".\n Without Target Lesions Response - "
        if (smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]) {
          if (smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]["nonTargetLesionsResponse"]) {
            pastTreatmentMessage += `Non Target Lesions Response : ${smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]["nonTargetLesionsResponse"]}`
          }
          if (smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]["newLesions"]) {
            pastTreatmentMessage += `, New Lesions : ${smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]["newLesions"]}`
          }
          if (smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]["overallResponse"]) {
            pastTreatmentMessage += `, Overall Response : ${smartSummaryData?.pastTreatment[index]["withoutTargetLesions"][0]["overallResponse"]}`
          }
        } else {
          pastTreatmentMessage += "NA"
        }
      }
    } else {
      return "NA"
    }
    return pastTreatmentMessage
  }

  const getCurrentTreatment = (index: any) => {
    let currentTreatmentMessage = ""
    if (smartSummaryData?.currentTreatmentPlan === null) {
      return "NA"
    } else if (Object.keys(smartSummaryData?.currentTreatmentPlan[index]).length > 0) {
      let data: any = Object.keys(smartSummaryData?.currentTreatmentPlan[index])
      if (data?.length > 0) {
        const treatmentIntentKey = data?.find((item: any) => item?.includes("treatmentIntent")) || null;
        const lineOfTreatmentKey = data?.find((item: any) => item?.includes("lineOfTreatment")) || null;
        const typeOfIssueKey = data?.find((item: any) => item?.includes("typeOfIssue")) || null;
        const maintenanceTreatmentKey = data?.find((item: any) => item?.includes("maintenanceTreatment")) || null;
        const noOfCyclesMaintenanceTreatmentKey = data?.find((item: any) => item?.includes("noOfCyclesMaintenanceTreatment")) || null;

        if (treatmentIntentKey && smartSummaryData?.currentTreatmentPlan[index][treatmentIntentKey]) {
          currentTreatmentMessage += `Treatment Intent : ${smartSummaryData?.currentTreatmentPlan[index][treatmentIntentKey]}`
        }
        if (lineOfTreatmentKey && smartSummaryData?.currentTreatmentPlan[index][lineOfTreatmentKey]) {
          currentTreatmentMessage += `${smartSummaryData?.currentTreatmentPlan[index][treatmentIntentKey] ? ", " : ""} Line Of Treatment : ${smartSummaryData?.currentTreatmentPlan[index][lineOfTreatmentKey]}`
        }
        if (typeOfIssueKey && smartSummaryData?.currentTreatmentPlan[index][typeOfIssueKey]) {
          currentTreatmentMessage += `${smartSummaryData?.currentTreatmentPlan[index][lineOfTreatmentKey] ? ", " : ""} Type : ${smartSummaryData?.currentTreatmentPlan[index][typeOfIssueKey]}`
        }
        if (maintenanceTreatmentKey && smartSummaryData?.currentTreatmentPlan[index][maintenanceTreatmentKey]) {
          currentTreatmentMessage += `${smartSummaryData?.currentTreatmentPlan[index][typeOfIssueKey] ? ", " : ""} Maintenance Treatment : ${smartSummaryData?.currentTreatmentPlan[index][maintenanceTreatmentKey] === "other" ?
            smartSummaryData?.currentTreatmentPlan[index][`${maintenanceTreatmentKey}-Comment`] ?
              smartSummaryData?.currentTreatmentPlan[index][`${maintenanceTreatmentKey}-Comment`] : ""
            : smartSummaryData?.currentTreatmentPlan[index][maintenanceTreatmentKey]}`
        }
        if (noOfCyclesMaintenanceTreatmentKey && smartSummaryData?.currentTreatmentPlan[index][noOfCyclesMaintenanceTreatmentKey]) {
          currentTreatmentMessage += `${smartSummaryData?.currentTreatmentPlan[index][maintenanceTreatmentKey] ? ", " : ""} No of Cycles : ${smartSummaryData?.currentTreatmentPlan[index][noOfCyclesMaintenanceTreatmentKey]}`
        }
      } else {
        currentTreatmentMessage = " NA"
      }
      return currentTreatmentMessage
    } else {
      return "NA"
    }
  }

  const getCurrentTreatmentType = (treatment: any) => {
    let treatmentTypeStr = ""
    if (Object.keys(treatment).length > 0) {
      const dataKeys = Object.keys(treatment)
      if (dataKeys?.length > 0) {

        const typeOfTreatmentSelectedKey: any = dataKeys?.find((element: any) => element?.includes("typeOfTreatmentSelected")) || null;

        const detailsOfTreatmentKey: any = dataKeys?.find((element: any) => element?.includes("detailsOfTreatment")) || null;

        const currentTreatmentKey: any = dataKeys?.find((element: any) => element?.includes("currentTreatment")) || null;

        const targetedTherapyKey: any = dataKeys?.find((element: any) => element?.includes("targetedTherapy")) || null;

        const noOfCyclesTargetedTherapyKey: any = dataKeys?.find((element: any) => element?.includes("noOfCyclesTargetedTherapy")) || null;

        const adjuvantKey: any = dataKeys?.find((element: any) => element?.includes("adjuvant")) || null;

        const multiAgentPalliativeKey: any = dataKeys?.find((element: any) => element?.includes("multiAgentPalliative")) || null;

        const nactKey: any = dataKeys?.find((element: any) => element?.includes("nact")) || null;

        const singleAgentKey: any = dataKeys?.find((element: any) => element?.includes("singleAgent")) || null;

        const noOfCyclesKey: any = dataKeys?.find((element: any) => element?.includes("noOfCycles")) || null;

        const typeOfRadiotherapyKey: any = dataKeys?.find((element: any) => element?.includes("typeOfRadiotherapy")) || null;

        const immunotherapyKey: any = dataKeys?.find((element: any) => element?.includes("immunotherapy")) || null;

        const her2NegativeImmunotherapyKey: any = dataKeys?.find((element: any) => element?.includes("her2NegativeImmunotherapy")) || null;

        const noOfCyclesImmunotherapyKey: any = dataKeys?.find((element: any) => element?.includes("noOfCyclesImmunotherapy")) || null;

        const ctrtKey: any = dataKeys?.find((element: any) => element?.includes("ctrt")) || null;

        const noOfCyclesCtrtKey: any = dataKeys?.find((element: any) => element?.includes("noOfCyclesCtrt")) || null;

        const interventionalRadiologyKey: any = dataKeys?.find((element: any) => element?.includes("interventionalRadiology")) || null;

        const boneModifyingAgentsKey: any = dataKeys?.find((element: any) => element?.includes("boneModifyingAgents")) || null;

        const her2PositiveKey: any = dataKeys?.find((element: any) => element?.includes("her2Positive")) || null;

        const antiHer2Key: any = dataKeys?.find((element: any) => element?.includes("antiHer2")) || null;

        const frequencyKey: any = dataKeys?.find((element: any) => element?.includes("frequency")) || null;

        const maintenanceKey: any = dataKeys?.find((element: any) => element?.includes("maintenance")) || null;

        const her2NegativeChemotherapyKey: any = dataKeys?.find((element: any) => element?.includes("her2NegativeChemotherapy")) || null;

        const normalDoseDenseKey: any = dataKeys?.find((element: any) => element?.includes("normalDoseDense")) || null;

        const combinationTherapiesKey: any = dataKeys?.find((element: any) => element?.includes("combinationTherapies")) || null;

        const advancedTreatmentKey: any = dataKeys?.find((element: any) => element?.includes("advancedTreatment")) || null;

        const riskBasedOnIPSSKey: any = dataKeys?.find((element: any) => element?.includes("riskBasedOnIPSS")) || null;

        const lowerRiskDiseaseKey: any = dataKeys?.find((element: any) => element?.includes("lowerRiskDisease")) || null;

        const higherRiskDiseaseKey: any = dataKeys?.find((element: any) => element?.includes("higherRiskDisease")) || null;

        const supportiveCareLRDKey: any = dataKeys?.find((element: any) => element?.includes("supportiveCareLRD")) || null;

        const SystemicLRDKey: any = dataKeys?.find((element: any) => element?.includes("systemicLRD")) || null;

        const SystemicHRDKey: any = dataKeys?.find((element: any) => element?.includes("SystemicHRD")) || null;

        const transplantCandidateKey: any = dataKeys?.find((element: any) => element?.includes("transplantCandidate")) || null;

        const supportiveCareHRDKey: any = dataKeys?.find((element: any) => element?.includes("supportiveCareHRD")) || null;

        const remarksKey: any = dataKeys?.find((element: any) => element?.includes("remarks")) || null;

        const metastaticKey: any = dataKeys?.find((element: any) => element?.includes("metastatic")) || null;

        const surgicalCastrationKey: any = dataKeys?.find((element: any) => element?.includes("surgicalCastration")) || null;

        const medicalCastrationKey: any = dataKeys?.find((element: any) => element?.includes("medicalCastration")) || null;

        const hormoneTherapyKey: any = dataKeys?.find((element: any) => element?.includes("hormoneTherapy")) || null;

        const noOfCyclesHormoneTherapyKey: any = dataKeys?.find((element: any) => element?.includes("noOfCyclesHormoneTherapy")) || null;

        const intravesicalTreatmentIndicatedKey: any = dataKeys?.find((element: any) => element?.includes("intravesicalTreatmentIndicated")) || null;

        const intravesicalTreatmentKey: any = dataKeys?.find((element: any) => element?.includes("intravesicalTreatment") && !element?.includes("intravesicalTreatmentIndicated")) || null;

        const riskStratificationKey: any = dataKeys?.find((element: any) => element?.includes("riskStratification")) || null;

        const positiveMarginKey: any = dataKeys?.find((element: any) => element?.includes("positiveMargin")) || null;

        const seminalVesicleInvasionKey: any = dataKeys?.find((element: any) => element?.includes("seminalVesicleInvasion")) || null;

        const extracapsularExtensionKey: any = dataKeys?.find((element: any) => element?.includes("extracapsularExtension")) || null;

        const psaLevelKey: any = dataKeys?.find((element: any) => element?.includes("psaLevel")) || null;

        const indicationKey: any = dataKeys?.find((element: any) => element?.includes("indication")) || null;

        if (typeOfTreatmentSelectedKey && treatment[typeOfTreatmentSelectedKey]) {
          if (treatment[typeOfTreatmentSelectedKey] === "Surgery" ||
            treatment[typeOfTreatmentSelectedKey] === "Maintenance Applicable" ||
            treatment[typeOfTreatmentSelectedKey] === "CTRT" ||
            treatment[typeOfTreatmentSelectedKey] === "Radiation" ||
            treatment[typeOfTreatmentSelectedKey] === "PRRT" ||
            treatment[typeOfTreatmentSelectedKey] === "LAR/ Octreotide") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Targeted Therapy") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (targetedTherapyKey && treatment[targetedTherapyKey]) {
              treatmentTypeStr += `, Targeted Therapy : ${treatment[targetedTherapyKey] === "other" ?
                treatment[`${targetedTherapyKey}-Comment`] ?
                  treatment[`${targetedTherapyKey}-Comment`] : ""
                : treatment[targetedTherapyKey]}`
            }
            if (noOfCyclesTargetedTherapyKey && treatment[noOfCyclesTargetedTherapyKey]) {
              treatmentTypeStr += `, No of Cycles : ${treatment[noOfCyclesTargetedTherapyKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Chemotherapy" ||
            treatment[typeOfTreatmentSelectedKey] === "Chemotherapy - Cisplatin Eligible" ||
            treatment[typeOfTreatmentSelectedKey] === "Chemotherapy - Cisplatin Ineligible" ||
            treatment[typeOfTreatmentSelectedKey] === "Cystectomy") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (adjuvantKey && treatment[adjuvantKey]) {
              treatmentTypeStr += `, Adjuvant : ${treatment[adjuvantKey] === "other" ?
                treatment[`${adjuvantKey}-Comment`] ?
                  treatment[`${adjuvantKey}-Comment`] : ""
                : treatment[adjuvantKey]}`
            }
            if (multiAgentPalliativeKey && treatment[multiAgentPalliativeKey]) {
              treatmentTypeStr += `, Multi Agent (Palliative) : ${treatment[multiAgentPalliativeKey] === "other" ?
                treatment[`${multiAgentPalliativeKey}-Comment`] ?
                  treatment[`${multiAgentPalliativeKey}-Comment`] : ""
                : treatment[multiAgentPalliativeKey]}`
            }
            if (nactKey && treatment[nactKey]) {
              treatmentTypeStr += `, NACT : ${treatment[nactKey] === "other" ?
                treatment[`${nactKey}-Comment`] ?
                  treatment[`${nactKey}-Comment`] : ""
                : treatment[nactKey]}`
            }
            if (singleAgentKey && treatment[singleAgentKey]) {
              treatmentTypeStr += `, Single Agent : ${treatment[singleAgentKey] === "other" ?
                treatment[`${singleAgentKey}-Comment`] ?
                  treatment[`${singleAgentKey}-Comment`] : ""
                : treatment[singleAgentKey]}`
            }
            if (noOfCyclesKey && treatment[noOfCyclesKey]) {
              treatmentTypeStr += `, No of Cycles : ${treatment[noOfCyclesKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details of Treatment : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Bone Modifying Agents" || treatment[typeOfTreatmentSelectedKey] === "Interventional Radiology" || treatment[typeOfTreatmentSelectedKey] === "Combination Therapies" || treatment[typeOfTreatmentSelectedKey] === "Advanced treatment" || treatment[typeOfTreatmentSelectedKey] === "Transplant" || treatment[typeOfTreatmentSelectedKey] === "Local Treatment") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (interventionalRadiologyKey && treatment[interventionalRadiologyKey]) {
              treatmentTypeStr += `, Interventional Radiology : ${treatment[interventionalRadiologyKey] === "other" ?
                treatment[`${interventionalRadiologyKey}-Comment`] ?
                  treatment[`${interventionalRadiologyKey}-Comment`] : ""
                : treatment[interventionalRadiologyKey]}`
            }
            if (boneModifyingAgentsKey && treatment[boneModifyingAgentsKey]) {
              treatmentTypeStr += `, Bone Modifying Agents : ${treatment[boneModifyingAgentsKey] === "other" ?
                treatment[`${boneModifyingAgentsKey}-Comment`] ?
                  treatment[`${boneModifyingAgentsKey}-Comment`] : ""
                : treatment[boneModifyingAgentsKey]}`
            }
            if (combinationTherapiesKey && treatment[combinationTherapiesKey]) {
              treatmentTypeStr += `, Combination Therapies : ${treatment[combinationTherapiesKey] === "other" ?
                treatment[`${combinationTherapiesKey}-Comment`] ?
                  treatment[`${combinationTherapiesKey}-Comment`] : ""
                : treatment[combinationTherapiesKey]}`
            }
            if (advancedTreatmentKey && treatment[advancedTreatmentKey]) {
              treatmentTypeStr += `, Advanced Treatment : ${treatment[advancedTreatmentKey] === "other" ?
                treatment[`${advancedTreatmentKey}-Comment`] ?
                  treatment[`${advancedTreatmentKey}-Comment`] : ""
                : treatment[advancedTreatmentKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details of Treatment : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Radiotherapy") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (typeOfRadiotherapyKey && treatment[typeOfRadiotherapyKey]) {
              treatmentTypeStr += `, Type of Radiotherapy : ${treatment[typeOfRadiotherapyKey] === "other" ?
                treatment[`${typeOfRadiotherapyKey}-Comment`] ?
                  treatment[`${typeOfRadiotherapyKey}-Comment`] : ""
                : treatment[typeOfRadiotherapyKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Hormone Therapy" || treatment[typeOfTreatmentSelectedKey] === "Nuclear Medicine") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (hormoneTherapyKey && treatment[hormoneTherapyKey]) {
              treatmentTypeStr += `, Hormone Therapy : ${treatment[hormoneTherapyKey] === "other" ?
                treatment[`${hormoneTherapyKey}-Comment`] ?
                  treatment[`${hormoneTherapyKey}-Comment`] : ""
                : treatment[hormoneTherapyKey]}`
            }
            if (noOfCyclesHormoneTherapyKey && treatment[noOfCyclesHormoneTherapyKey]) {
              treatmentTypeStr += `, No of Cycles : ${treatment[noOfCyclesHormoneTherapyKey] === "other" ?
                treatment[`${noOfCyclesHormoneTherapyKey}-Comment`] ?
                  treatment[`${noOfCyclesHormoneTherapyKey}-Comment`] : ""
                : treatment[noOfCyclesHormoneTherapyKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Immunotherapy") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (immunotherapyKey && treatment[immunotherapyKey]) {
              treatmentTypeStr += `, Immunotherapy : ${treatment[immunotherapyKey] === "other" ?
                treatment[`${immunotherapyKey}-Comment`] ?
                  treatment[`${immunotherapyKey}-Comment`] : ""
                : treatment[immunotherapyKey]}`
            }
            if (noOfCyclesImmunotherapyKey && treatment[noOfCyclesImmunotherapyKey]) {
              treatmentTypeStr += `, No of Cycles : ${treatment[noOfCyclesImmunotherapyKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "CTRT - Concurrent chemotherapy") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (ctrtKey && treatment[ctrtKey]) {
              treatmentTypeStr += `, CTRT : ${treatment[ctrtKey] === "other" ?
                treatment[`${ctrtKey}-Comment`] ?
                  treatment[`${ctrtKey}-Comment`] : ""
                : treatment[ctrtKey]}`
            }
            if (noOfCyclesCtrtKey && treatment[noOfCyclesCtrtKey]) {
              treatmentTypeStr += `, No of Cycles : ${treatment[noOfCyclesCtrtKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "HER2 Positive") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (her2PositiveKey && treatment[her2PositiveKey]) {
              treatmentTypeStr += `, HER2 Positive : ${treatment[her2PositiveKey] === "other" ?
                treatment[`${her2PositiveKey}-Comment`] ?
                  treatment[`${her2PositiveKey}-Comment`] : ""
                : treatment[her2PositiveKey]}`
            }
            if (antiHer2Key && treatment[antiHer2Key]) {
              treatmentTypeStr += `, Anti HER2 : ${treatment[antiHer2Key] === "other" ?
                treatment[`${antiHer2Key}-Comment`] ?
                  treatment[`${antiHer2Key}-Comment`] : ""
                : treatment[antiHer2Key]}`
            }
            if (frequencyKey && treatment[frequencyKey]) {
              treatmentTypeStr += `, Frequency : ${treatment[frequencyKey] === "other" ?
                treatment[`${frequencyKey}-Comment`] ?
                  treatment[`${frequencyKey}-Comment`] : ""
                : treatment[frequencyKey]}`
            }
            if (maintenanceKey && treatment[maintenanceKey]) {
              treatmentTypeStr += `, Maintenance : ${treatment[maintenanceKey] === "other" ?
                treatment[`${maintenanceKey}-Comment`] ?
                  treatment[`${maintenanceKey}-Comment`] : ""
                : treatment[maintenanceKey]}`
            }
            if (noOfCyclesKey && treatment[noOfCyclesKey]) {
              treatmentTypeStr += `, Number of Cycles : ${treatment[noOfCyclesKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "HER2 Negative") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (her2NegativeImmunotherapyKey && treatment[her2NegativeImmunotherapyKey]) {
              treatmentTypeStr += `, Immunotherapy : ${treatment[her2NegativeImmunotherapyKey] === "other" ?
                treatment[`${her2NegativeImmunotherapyKey}-Comment`] ?
                  treatment[`${her2NegativeImmunotherapyKey}-Comment`] : ""
                : treatment[her2NegativeImmunotherapyKey]}`
            }
            if (her2NegativeChemotherapyKey && treatment[her2NegativeChemotherapyKey]) {
              treatmentTypeStr += `, Chemotherapy : ${treatment[her2NegativeChemotherapyKey] === "other" ?
                treatment[`${her2NegativeChemotherapyKey}-Comment`] ?
                  treatment[`${her2NegativeChemotherapyKey}-Comment`] : ""
                : treatment[her2NegativeChemotherapyKey]}`
            }
            if (normalDoseDenseKey && treatment[normalDoseDenseKey]) {
              treatmentTypeStr += `, Dose Dense: ${treatment[normalDoseDenseKey] === "other" ?
                treatment[`${normalDoseDenseKey}-Comment`] ?
                  treatment[`${normalDoseDenseKey}-Comment`] : ""
                : treatment[normalDoseDenseKey]}`
            }
            if (noOfCyclesKey && treatment[noOfCyclesKey]) {
              treatmentTypeStr += `, Number of Cycles : ${treatment[noOfCyclesKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Others" ||
            treatment[typeOfTreatmentSelectedKey] === "Intrathecal") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
            if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey]) {
              treatmentTypeStr += `, Details of Treatment : ${treatment[detailsOfTreatmentKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Surgical Castration" || treatment[typeOfTreatmentSelectedKey] === "Medical Castration") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (metastaticKey && treatment[metastaticKey]) {
              treatmentTypeStr += `, Metastatic : ${treatment[metastaticKey]}`
            }
            if (surgicalCastrationKey && treatment[surgicalCastrationKey]) {
              treatmentTypeStr += `, Surgical Castration : ${treatment[surgicalCastrationKey] === "other" ?
                treatment[`${surgicalCastrationKey}-Comment`] ?
                  treatment[`${surgicalCastrationKey}-Comment`] : ""
                : treatment[surgicalCastrationKey]}`
            }
            if (medicalCastrationKey && treatment[medicalCastrationKey]) {
              treatmentTypeStr += `, Medical Castration : ${treatment[medicalCastrationKey] === "other" ?
                treatment[`${medicalCastrationKey}-Comment`] ?
                  treatment[`${medicalCastrationKey}-Comment`] : ""
                : treatment[medicalCastrationKey]}`
            }
          }
          else if (treatment[typeOfTreatmentSelectedKey] === "Adjuvant Treatment") {
            treatmentTypeStr += `Type of Treatment : ${treatment[typeOfTreatmentSelectedKey]}`
            if (positiveMarginKey && treatment[positiveMarginKey]) {
              treatmentTypeStr += `, Positive margin(s) : ${treatment[positiveMarginKey] === "other" ?
                treatment[`${positiveMarginKey}-Comment`] ?
                  treatment[`${positiveMarginKey}-Comment`] : ""
                : treatment[positiveMarginKey]}`
            }
            if (seminalVesicleInvasionKey && treatment[seminalVesicleInvasionKey]) {
              treatmentTypeStr += `, Seminal vesicle invasion : ${treatment[seminalVesicleInvasionKey] === "other" ?
                treatment[`${seminalVesicleInvasionKey}-Comment`] ?
                  treatment[`${seminalVesicleInvasionKey}-Comment`] : ""
                : treatment[seminalVesicleInvasionKey]}`
            }
            if (extracapsularExtensionKey && treatment[extracapsularExtensionKey]) {
              treatmentTypeStr += `, Extracapsular extension : ${treatment[extracapsularExtensionKey] === "other" ?
                treatment[`${extracapsularExtensionKey}-Comment`] ?
                  treatment[`${extracapsularExtensionKey}-Comment`] : ""
                : treatment[extracapsularExtensionKey]}`
            }
            if (psaLevelKey && treatment[psaLevelKey]) {
              treatmentTypeStr += `, PSA level : ${treatment[psaLevelKey] === "other" ?
                treatment[`${psaLevelKey}-Comment`] ?
                  treatment[`${psaLevelKey}-Comment`] : ""
                : treatment[psaLevelKey]}`
            }
            if (indicationKey && treatment[indicationKey]) {
              treatmentTypeStr += `, Indication : ${treatment[indicationKey] === "other" ?
                treatment[`${indicationKey}-Comment`] ?
                  treatment[`${indicationKey}-Comment`] : ""
                : treatment[indicationKey]}`
            }
            if (currentTreatmentKey && treatment[currentTreatmentKey]) {
              treatmentTypeStr += `, Current Treatment : ${treatment[currentTreatmentKey]}`
            }
          }
        } else if (riskBasedOnIPSSKey && treatment[riskBasedOnIPSSKey]) {
          if (riskBasedOnIPSSKey && treatment[riskBasedOnIPSSKey]) {
            treatmentTypeStr += `Risk Based On IPSS-R : ${treatment[riskBasedOnIPSSKey] === "other" ?
              treatment[`${riskBasedOnIPSSKey}-Comment`] ?
                treatment[`${riskBasedOnIPSSKey}-Comment`] : ""
              : treatment[riskBasedOnIPSSKey]}`
          }
          if (lowerRiskDiseaseKey && treatment[lowerRiskDiseaseKey]) {
            treatmentTypeStr += `, Lower risk Disease : ${treatment[lowerRiskDiseaseKey] === "other" ?
              treatment[`${lowerRiskDiseaseKey}-Comment`] ?
                treatment[`${lowerRiskDiseaseKey}-Comment`] : ""
              : treatment[lowerRiskDiseaseKey]}`
          }
          if (higherRiskDiseaseKey && treatment[higherRiskDiseaseKey]) {
            treatmentTypeStr += `, Higher risk Disease : ${treatment[higherRiskDiseaseKey] === "other" ?
              treatment[`${higherRiskDiseaseKey}-Comment`] ?
                treatment[`${higherRiskDiseaseKey}-Comment`] : ""
              : treatment[higherRiskDiseaseKey]}`
          }
          if (supportiveCareLRDKey && treatment[supportiveCareLRDKey]) {
            treatmentTypeStr += `, Supportive Care : ${treatment[supportiveCareLRDKey] === "other" ?
              treatment[`${supportiveCareLRDKey}-Comment`] ?
                treatment[`${supportiveCareLRDKey}-Comment`] : ""
              : treatment[supportiveCareLRDKey]}`
          }
          if (SystemicLRDKey && treatment[SystemicLRDKey]) {
            treatmentTypeStr += `, Systemic : ${treatment[SystemicLRDKey] === "other" ?
              treatment[`${SystemicLRDKey}-Comment`] ?
                treatment[`${SystemicLRDKey}-Comment`] : ""
              : treatment[SystemicLRDKey]}`
          }
          if (SystemicHRDKey && treatment[SystemicHRDKey]) {
            treatmentTypeStr += `, Systemic : ${treatment[SystemicHRDKey] === "other" ?
              treatment[`${SystemicHRDKey}-Comment`] ?
                treatment[`${SystemicHRDKey}-Comment`] : ""
              : treatment[SystemicHRDKey]}`
          }
          if (transplantCandidateKey && treatment[transplantCandidateKey]) {
            treatmentTypeStr += `, Transplant Candidate : ${treatment[transplantCandidateKey] === "other" ?
              treatment[`${transplantCandidateKey}-Comment`] ?
                treatment[`${transplantCandidateKey}-Comment`] : ""
              : treatment[transplantCandidateKey]}`
          }
          if (supportiveCareHRDKey && treatment[supportiveCareHRDKey]) {
            treatmentTypeStr += `, Supportive Care : ${treatment[supportiveCareHRDKey] === "other" ?
              treatment[`${supportiveCareHRDKey}-Comment`] ?
                treatment[`${supportiveCareHRDKey}-Comment`] : ""
              : treatment[supportiveCareHRDKey]}`
          }
          if (noOfCyclesKey && treatment[noOfCyclesKey]) {
            treatmentTypeStr += `, Number of Cycles : ${treatment[noOfCyclesKey]}`
          }
          if (remarksKey && treatment[remarksKey]) {
            treatmentTypeStr += `, Remarks : ${treatment[remarksKey]}`
          }
        } else if (treatment[metastaticKey] === "Bone Modifying Agents") {
          if (metastaticKey && treatment[metastaticKey]) {
            treatmentTypeStr += `Metastatic : ${treatment[metastaticKey]}`
          }
          if (boneModifyingAgentsKey && treatment[boneModifyingAgentsKey]) {
            treatmentTypeStr += `, Bone Modifying Agents : ${treatment[boneModifyingAgentsKey] === "other" ?
              treatment[`${boneModifyingAgentsKey}-Comment`] ?
                treatment[`${boneModifyingAgentsKey}-Comment`] : ""
              : treatment[boneModifyingAgentsKey]}`
          }
        } else if (intravesicalTreatmentIndicatedKey && treatment[intravesicalTreatmentIndicatedKey]) {
          if (
            intravesicalTreatmentIndicatedKey && treatment[intravesicalTreatmentIndicatedKey]
          ) {
            treatmentTypeStr += `Intravesical treatment indicated : ${treatment[intravesicalTreatmentIndicatedKey]}`
          }
          if (
            intravesicalTreatmentKey && treatment[intravesicalTreatmentKey] && treatment[intravesicalTreatmentIndicatedKey] === "Yes"
          ) {
            treatmentTypeStr += `, Intravesical treatment : ${treatment[intravesicalTreatmentKey] === "other" ?
              treatment[`${intravesicalTreatmentKey}-Comment`] ?
                treatment[`${intravesicalTreatmentKey}-Comment`] : ""
              : treatment[intravesicalTreatmentKey]}`
          }
          if (
            riskStratificationKey && treatment[riskStratificationKey]
          ) {
            treatmentTypeStr += `, Risk Stratification : ${treatment[riskStratificationKey] === "other" ?
              treatment[`${riskStratificationKey}-Comment`] ?
                treatment[`${riskStratificationKey}-Comment`] : ""
              : treatment[riskStratificationKey]}`
          }
          if (detailsOfTreatmentKey && treatment[detailsOfTreatmentKey] && treatment[riskStratificationKey] === "High Risk") {
            treatmentTypeStr += `, Details : ${treatment[detailsOfTreatmentKey]}`
          }
        }
      }
      return treatmentTypeStr
    } else {
      return "NA"
    }
  }

  const getMolecularMarkers = (index: any) => {
    let molecularMarkerElement: any
    const elementsList: any = [];
    if (smartSummaryData?.molecularMarkers === null) {
      elementsList.push(<span>NA</span>);
    } else if (Object.keys(smartSummaryData?.molecularMarkers[index]).length > 0) {
      let data: any = Object.keys(smartSummaryData?.molecularMarkers[index]);

      if (data?.length > 0) {
        if (
          (smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"] !== null && smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"] !== undefined) ||
          (smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc-Comment"] !== null && smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc-Comment"] !== undefined)
        ) {
          elementsList.push(
            <span className="bold-text">{
              smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"] ?
                smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"] === "other" && smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc-Comment"] ? smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc-Comment"]
                  : smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"]
                : "NA"}</span>
          );
        }

        if (smartSummaryData?.molecularMarkers[index]["mmDate"] !== null && smartSummaryData?.molecularMarkers[index]["mmDate"] !== undefined) {
          elementsList.push(
            <> On <span className="bold-text">{smartSummaryData?.molecularMarkers[index]["mmDate"] ? moment(smartSummaryData?.molecularMarkers[index]["mmDate"]).format("DD-MM-YYYY") : "NA"}</span></>
          );
        }

        if (smartSummaryData?.molecularMarkers[index]["mmResult"] !== null && smartSummaryData?.molecularMarkers[index]["mmResult"] !== undefined) {
          elementsList.push(
            <span>, Result: {smartSummaryData?.molecularMarkers[index]["mmResult"] ? smartSummaryData?.molecularMarkers[index]["mmResult"] : "NA"}</span>
          );
        }

        if (smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"] !== null && smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"] !== undefined) {
          const markerDesc = smartSummaryData?.molecularMarkers[index]["molecularMarkerDesc"];
          if (markerDesc === "NRAS" && smartSummaryData?.molecularMarkers[index]["NRAS"]) {
            elementsList.push(<>, <span className="bold-text">NRAS: </span>{smartSummaryData?.molecularMarkers[index]["NRAS"]}</>);
          } else if (markerDesc === "KRAS" && smartSummaryData?.molecularMarkers[index]["KRAS"]) {
            elementsList.push(<>, <span className="bold-text">KRAS: </span>{smartSummaryData?.molecularMarkers[index]["KRAS"]}</>);
          } else if (markerDesc === "BRAF" && smartSummaryData?.molecularMarkers[index]["BRAF"]) {
            elementsList.push(<>, <span className="bold-text">BRAF: </span>{smartSummaryData?.molecularMarkers[index]["BRAF"]}</>);
          } else if (markerDesc === "HER2" && smartSummaryData?.molecularMarkers[index]["HER2"]) {
            elementsList.push(<>, <span className="bold-text">HER2: </span>{smartSummaryData?.molecularMarkers[index]["HER2"]}</>);
          } else if (markerDesc === "MSI/MMR" && smartSummaryData?.molecularMarkers[index]["msiMmr"]) {
            elementsList.push(<>, <span className="bold-text">MSI / MMR: </span>{smartSummaryData?.molecularMarkers[index]["msiMmr"]}</>);
          } else if (markerDesc === "PDL1" && smartSummaryData?.molecularMarkers[index]["pdl1"]) {
            elementsList.push(<>, <span className="bold-text">PDL1: </span>{smartSummaryData?.molecularMarkers[index]["pdl1"]}</>);
            if (smartSummaryData?.molecularMarkers[index]["pdl1Percentage"]) {
              elementsList.push(<>, <span className="bold-text">Percentage: </span>{smartSummaryData?.molecularMarkers[index]["pdl1Percentage"]}</>);
            }
            if (smartSummaryData?.molecularMarkers[index]["pdl1Platform"]) {
              elementsList.push(<>, <span className="bold-text">Platform: </span>{smartSummaryData?.molecularMarkers[index]["pdl1Platform"]}</>);
            }
          }
        }
      }
    } else {
      elementsList.push(<span>NA</span>);
    }
    molecularMarkerElement = <>{elementsList}</>
    return molecularMarkerElement;
  };

  const getTumorMarkers = (index: any) => {
    let tumorMarkerElement: any
    const elementsList: any = [];
    if (smartSummaryData?.tumorMarkers === null) {
      elementsList.push(<span>NA</span>);
    } else if (Object.keys(smartSummaryData?.tumorMarkers[index]).length > 0) {
      let data = Object.keys(smartSummaryData?.tumorMarkers[index])
      if (data.length === 1) {
        elementsList.push(<span>NA</span>);
      } else if (data.length > 1) {
        if (data.includes("tumorMarkerDesc") && smartSummaryData?.tumorMarkers[index]["tumorMarkerDesc"]) {
          if (smartSummaryData?.tumorMarkers[index]["tumorMarkerDesc"] === "other") {
            elementsList.push(<span className="bold-text">{smartSummaryData?.tumorMarkers[index]["tumorMarkerDesc-Comment"]}</span>)
          } else {
            elementsList.push(<span className="bold-text">{smartSummaryData?.tumorMarkers[index]["tumorMarkerDesc"]}</span>)
          }
        }
        if (data.includes("tmDate") && smartSummaryData?.tumorMarkers[index]["tmDate"]) {
          elementsList.push(<> On <span className="bold-text">{moment(smartSummaryData?.tumorMarkers[index]["tmDate"]).format("DD-MM-YYYY")}</span></>)
        }
        if (data.includes("tmResult") && smartSummaryData?.tumorMarkers[index]["tmResult"]) {
          elementsList.push(<span>, {smartSummaryData?.tumorMarkers[index]["tmResult"]} </span>)
        }
      }
    } else {
      elementsList.push(<span>NA</span>);
    }
    tumorMarkerElement = <>{elementsList}</>;
    return tumorMarkerElement
  }

  return (
    <div className="diagnostic-report">
      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${!smartSummaryData?.briefHistory ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Brief History:</span>
        <ul>
          {
            smartSummaryData?.briefHistory ? (
              <li style={{ marginBottom: "5px" }} className="textarea-content">{smartSummaryData.briefHistory}</li>
            ) : (
              <li>NA</li>
            )
          }
        </ul>
      </p>
      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${(!smartSummaryData?.histopathology || (Array.isArray(smartSummaryData?.histopathology) && smartSummaryData?.histopathology?.length <= 0)) ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Histopath:</span>
        <ul>
          {
            smartSummaryData?.histopathology ? (
              smartSummaryData?.histopathology?.map((ele: any, index: any) => {
                {
                  return smartSummaryData?.histopathology?.length > 1 ?
                    <li style={{ marginBottom: "5px" }}>{ele?.value ? ele?.value : ""} &nbsp;({smartSummaryData?.diagnosis[index]?.cancerType}){ele?.date ? `, Date : ${moment(ele?.date)?.format("DD-MM-YYYY")}` : ""}</li>
                    :
                    <li style={{ marginBottom: "5px" }}>{ele?.value ? ele?.value : ""}{ele?.date ? `, Date : ${moment(ele?.date)?.format("DD-MM-YYYY")}` : ""}</li>
                }
              })
            ) : (
              <li>NA</li>
            )
          }
        </ul>
      </p>

      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${(!smartSummaryData?.molecularMarkers || (Array.isArray(smartSummaryData?.molecularMarkers) && smartSummaryData?.molecularMarkers?.length <= 0)) ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Molecular markers:</span><br />
        {

          smartSummaryData?.molecularMarkers?.length > 0 ? (
            <ul>
              {
                smartSummaryData?.molecularMarkers?.map((m: any, index: any) => {
                  return (
                    <li style={{ marginBottom: "5px" }}>
                      {getMolecularMarkers(index)}
                    </li>
                  )
                })
              }
            </ul>
          ) : (
            <ul>
              <li style={{ marginBottom: "5px" }}>NA</li>
            </ul>
          )
        }
      </p>

      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${(!smartSummaryData?.tumorMarkers || (Array.isArray(smartSummaryData?.tumorMarkers) && smartSummaryData?.tumorMarkers?.length <= 0)) ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Tumor markers:</span><br />
        {

          smartSummaryData?.tumorMarkers?.length > 0 ? (
            <ul>
              {
                smartSummaryData?.tumorMarkers?.map((m: any, index: any) => {
                  return (
                    <li style={{ marginBottom: "5px" }}>
                      {getTumorMarkers(index)}
                    </li>
                  )
                })
              }
            </ul>
          ) : (
            <ul>
              <li style={{ marginBottom: "5px" }}>NA</li>
            </ul>
          )
        }
      </p>

      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${(!smartSummaryData?.lastScan || (Array.isArray(smartSummaryData?.lastScan) && smartSummaryData?.lastScan?.length <= 0)) ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Last scan with date:</span>
        <ul>
          <li style={{ marginBottom: "5px" }}>{getLastScan()}</li>
        </ul>
      </p>

      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${(!smartSummaryData?.pastTreatment || (Array.isArray(smartSummaryData?.pastTreatment) && smartSummaryData?.pastTreatment?.length <= 0)) ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Past treatment in chronology with dates:</span>
        {

          smartSummaryData?.pastTreatment?.length > 0 ? (
            <ul>
              {
                smartSummaryData?.pastTreatment?.map((m: any, index: any) => {
                  return (
                    <li style={{ marginBottom: "5px" }}>
                      {getPastTreatment(index)}
                    </li>
                  )
                })
              }
            </ul>
          ) : (
            <ul>
              <li style={{ marginBottom: "5px" }}>NA</li>
            </ul>
          )
        }
      </p>

      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${(!smartSummaryData?.currentTreatmentPlan || (Array.isArray(smartSummaryData?.currentTreatmentPlan) && smartSummaryData?.currentTreatmentPlan?.length <= 0)) ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Current treatment plan:</span>
        {
          smartSummaryData?.currentTreatmentPlan?.length > 0 ? (
            <ul>
              {
                smartSummaryData?.currentTreatmentPlan?.map((m: any, index: any) => {
                  const typeOfTreatmentKey: any = Object.keys(m)?.find((element: any) => element?.includes("typeOfTreatment")) || null;

                  const riskBasedOnIPSSKey: any = Object.keys(m)?.find((element: any) => element?.includes("riskBasedOnIPSS")) || null;

                  const nonMuscleInvasiveKey: any = Object.keys(m)?.find((element: any) => element?.includes("nonMuscleInvasive")) || null;

                  return (
                    <li style={{ marginBottom: "5px" }}>
                      {getCurrentTreatment(index)}
                      {
                        typeOfTreatmentKey ? (
                          <>
                            <p style={{ marginBottom: "5px" }}>Treatment Types</p>
                            <ol>
                              {
                                m[typeOfTreatmentKey]?.map((t: any, i: any) => {
                                  return (
                                    <li style={{ marginBottom: "5px" }}>
                                      {getCurrentTreatmentType(t)}
                                    </li>
                                  )
                                })
                              }
                            </ol>
                          </>
                        ) : riskBasedOnIPSSKey ? (
                          <>
                            <li style={{ marginBottom: "5px" }}>
                              {getCurrentTreatmentType(m)}
                            </li>
                          </>
                        ) : nonMuscleInvasiveKey ? (
                          <>
                            <p style={{ marginBottom: "5px" }}>Treatment Types</p>
                            <ol>
                              {
                                m[nonMuscleInvasiveKey]?.map((t: any, i: any) => {
                                  return (
                                    <li style={{ marginBottom: "5px" }}>
                                      {getCurrentTreatmentType(t)}
                                    </li>
                                  )
                                })
                              }
                            </ol>
                          </>
                        ) : null
                      }
                    </li>
                  )
                })
              }
            </ul>
          ) : (
            <ul>
              <li style={{ marginBottom: "5px" }}>NA</li>
            </ul>
          )
        }
      </p>

      <p
        style={{
          fontWeight: page === 'dischargeSummary' ? '400' : 'bold',
        }}
        className={`diagnostic-report-row ${!smartSummaryData?.lastCycle && !smartSummaryData?.toxicity ? "print-hidden" : ""}`}
      >
        <span className="diagnostic-report-row-heading">Last cycle received with tolerance:</span>
        <ul>
          <li>{`${smartSummaryData?.lastCycle ? `Cycle ${smartSummaryData?.lastCycle}` : ""} ${smartSummaryData?.toxicity ? ` with ${smartSummaryData?.toxicity}` : ""}${(!smartSummaryData?.lastCycle && !smartSummaryData?.toxicity) ? "NA" : ""} `}</li>
        </ul>
      </p>
    </div >
  )
}

export default RenderDiagnosticReport
